import {
  country,
  gmt,
  imageSizes,
} from "../../../helpers/imgGenerator/ecoCalendarObj";
import {
  DateOrdinal,
  Months,
  WeekDays,
} from "../../../utilities/utilityService";
import { ImageSizeSelector } from "../../../layouts/imageSizeSelector";
import { CustomSelect } from "../../../layouts/customSelect";
import { TranslateInput } from "../../../services/firebaseActions/language";

function EcoCalendar(props) {
  const { add, remove } = props.handleEcoItem();

  var days = WeekDays();
  const date = new Date();
  var months = Months();

  const daysString = days.join(", ");
  var translated = TranslateInput(daysString, "en", props.data.ecoLang);
  days = translated.split(",").map((day) => day.trim());

  const monthString = months.join(", ");
  var translatedMonth = TranslateInput(monthString, "en", props.data.ecoLang);
  months = translatedMonth.split(",").map((day) => day.trim());

  const dateRange = (from, to) => {
    const date = new Date(from);
    const date2 = new Date(to);
    let timeZone =
      "GMT" +
      (date.getTimezoneOffset() / 60 < 0 ? "+" : "-") +
      Math.abs(date.getTimezoneOffset() / 60);

    let dateRange = `${[days[date.getDay()]]} ${DateOrdinal(date.getDate())} ${
      months[date.getMonth()]
    } - ${[days[date2.getDay()]]} ${DateOrdinal(date2.getDate())} ${
      months[date2.getMonth()]
    }`;

    let gmt = props.data.ecoGMT ? props.data.ecoGMT : timeZone;

    return { dateRange, gmt };
  };

  return (
    <div className="ecoCalendar">
      <div className="grid grid-cols-12 gap-8 sm:px-4">
        <div className="col-span-12 sm:col-span-12 lg:col-span-5">
          <p className="mb-6">
            Create and customise your image by using the fields below.
          </p>

          <form>
            <div>
              <h3 className="font-display text-lg font-bold text-sub mb-5">
                Image Settings
              </h3>

              <div className="image-details">
                <div className="flex justify-left">
                  <ImageSizeSelector
                    handleChange={props.handleChange}
                    sizeObj={imageSizes}
                    name="ecoOverlay"
                  />
                </div>
                <div className="input-group mt-5">
                  <h3 className="font-display text-lg font-bold text-sub mb-5">
                    Custom Background
                  </h3>
                  <div className="custom-file relative">
                    <div className="w-full max-w-xl">
                      <label
                        htmlFor="dropzone-file"
                        className="flex flex-col justify-center items-center w-full h-32 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                      >
                        <div className="flex flex-col justify-center items-center pt-5 pb-6">
                          <svg
                            aria-hidden="true"
                            className="mb-3 w-10 h-10 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            ></path>
                          </svg>
                          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                            <span className="font-semibold">
                              Click to upload
                            </span>{" "}
                            or drag and drop
                          </p>

                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            780x780px for best results
                          </p>
                        </div>
                        <input
                          onChange={props.handleUploadEco}
                          type="file"
                          className="custom-file-input block w-full font-body text-sm text-sub cursor-pointer absolute h-full color-transparent -indent-56 focus:border-gogreen focus:ring-gogreen"
                          id="inputGroupFile04"
                          aria-describedby="inputGroupFileAddon04"
                          accept="image/x-png,image/gif,image/jpeg"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="font-display text-base font-bold text-sub mb-1">
                Image Details
              </h3>
              <p className="mb-3">Enter date range below</p>

              <div className="flex gap-5">
                <div className="block">
                  <label
                    className="font-body text-sm font-normal text-su block"
                    htmlFor="ecoDateFrom"
                  >
                    From
                  </label>

                  <input
                    type="date"
                    className="form-control mb-2 w-22 text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                    name="ecoDateFrom"
                    value={
                      props.data?.ecoDateFrom ||
                      date.toISOString().split("T")[0]
                    }
                    onChange={props.handleChange}
                  />
                </div>

                <div className="block">
                  <label
                    className="font-body text-sm font-normal text-sub block"
                    htmlFor="ecoDateFrom"
                  >
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control mb-2 w-22 text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                    name="ecoDateTo"
                    value={
                      props.data?.ecoDateTo || date.toISOString().split("T")[0]
                    }
                    onChange={props.handleChange}
                  />
                </div>
              </div>
              <div className="flex gap-5 mt-4">
                <div className="block">
                  <label
                    className="font-body text-sm font-normal text-sub block"
                    htmlFor="ecoGMT"
                  >
                    GMT
                  </label>
                  <select
                    defaultValue={"DEFAULT"}
                    onChange={props.handleChange}
                    className="form-control mb-2 w-22 text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                    id="simple-select"
                    label="GMT"
                    name="ecoGMT"
                  >
                    <option disabled={true} value="DEFAULT">
                      Select GMT
                    </option>
                    {gmt &&
                      [...gmt].map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.value}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="block">
                  <label
                    className="font-body text-sm font-normal text-sub block"
                    htmlFor="ecoDomain"
                  >
                    Domain
                  </label>
                  <CustomSelect
                    handleChange={props.handleChange}
                    name={"ecoDomain"}
                    id={"domain-select"}
                    label={"Domain"}
                    obj={[
                      { name: "gomarkets.com", value: "gomarkets.com" },
                      { name: "gomarkets.eu", value: "gomarkets.eu" },
                      { name: "gomarkets.ltd", value: "gomarkets.ltd" },
                      {
                        name: "gomarkets.com/pt-br",
                        value: "gomarkets.com/pt-br",
                      },
                      {
                        name: "gomarkets.com/es",
                        value: "gomarkets.com/es",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="flex gap-5 mt-4">
                <div className="block">
                  <label
                    className="font-body text-sm font-normal text-sub block"
                    htmlFor="ecoLang"
                  >
                    Language
                  </label>
                  <CustomSelect
                    handleChange={props.handleChange}
                    name={"ecoLang"}
                    id={"lang-select"}
                    label={"Language"}
                    obj={[
                      { name: "English", value: "en" },
                      { name: "Spanish", value: "es" },
                      { name: "Portuguese", value: "pt" },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="font-display text-base font-bold text-sub mb-1">
                Event Details
              </h3>
              <p className="mb-6">Enter the calendar details below</p>

              {Array(props.data.ecoCount)
                .fill()
                .map((_, index) => {
                  return (
                    <div key={index}>
                      <div>
                        <label className="font-body text-sm font-normal text-sub">
                          Item {index + 1}
                        </label>
                      </div>
                      <div>
                        <select
                          defaultValue={"DEFAULT"}
                          onChange={props.handleEcoChange}
                          className="w-2/5 border-border mb-2 cursor-pointer text-sm focus:border-gogreen focus:ring-gogreen"
                          id="simple-select"
                          label="Select Country"
                          name={`ecoCountry${index}`}
                        >
                          <option disabled={true} value="DEFAULT">
                            Select Country
                          </option>
                          {country &&
                            [...country].map((item, index) => {
                              return (
                                <option key={index} value={item.image}>
                                  {item.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="flex gap-1 flex-wrap">
                        <select
                          defaultValue={"DEFAULT"}
                          onChange={props.handleEcoChange}
                          className="form-control mb-2 w-22 text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                          id="simple-select"
                          label="Select day"
                          name={`ecoDay${index}`}
                        >
                          <option disabled={true} value="DEFAULT">
                            Select Day
                          </option>
                          {days &&
                            days.map((item, index) => {
                              return (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              );
                            })}
                        </select>

                        <input
                          type="text"
                          className="form-control mb-2 w-22 text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                          name={`ecoTime${index}`}
                          value={props.data.ecoDetails[index]?.ecoTime || ""}
                          onChange={props.handleEcoChange}
                          placeholder="Input time"
                        />
                        <input
                          className="form-control mb-2 w-[201px] text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                          type="text"
                          placeholder="Country/event"
                          name={`ecoEvent${index}`}
                          onChange={props.handleEcoChange}
                        />
                      </div>
                      <div className="flex gap-1 items-center">
                        <input
                          className="form-control mb-2 w-[6.5rem] text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                          type="text"
                          placeholder="Expected"
                          name={`ecoExpected${index}`}
                          onChange={props.handleEcoChange}
                        />
                        <input
                          className="form-control mb-2 w-[6.5rem] text-sm border border-border mt-1.5 focus:border-gogreen focus:ring-gogreen"
                          type="text"
                          placeholder="Previous"
                          name={`ecoPrevious${index}`}
                          onChange={props.handleEcoChange}
                        />
                      </div>
                    </div>
                  );
                })}
              <div className="flex justify-start w-100 gap-2">
                {props.data.ecoCount < 6 &&
                  props.data.ecoCount === props.data.ecoDetails.length && (
                    <button
                      className="btn-primary px-3 py-2 !font-semibold  text-xs ease-linear transition-all duration-150 rounded "
                      type="button"
                      name="ecoCount"
                      onClick={add}
                    >
                      Add
                    </button>
                  )}
                {props.data.ecoCount > 1 && (
                  <button
                    className="btn-primary px-3 py-2 !font-semibold  text-xs ease-linear transition-all duration-150 rounded "
                    type="button"
                    name="ecoCount"
                    onClick={remove}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>

        <div className="col-span-7 sm:pl-0 lg:pl-11">
          {/* Preview component */}
          <div
            id="gen-img-preview"
            style={{
              backgroundImage: `url("${props.data.ecoBgImg}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className={`DisplayImg  ${props.data.ecoOverlay} DisplayImgPreview hidden sm:hidden lg:block`}
          >
            <div id="top" className={props.data.ecoBgImg && "!bg-transparent"}>
              <div className="flex py-4 mr-5 badge-block">
                <span className="bg-primary text-[#fff] top-badge">
                  {
                    dateRange(props.data.ecoDateFrom, props.data.ecoDateTo)
                      .dateRange
                  }
                </span>
              </div>
              <div className="flex items-center text-block">
                <p className="font-inter">
                  {TranslateInput("Economic Events", "en", props.data.ecoLang)}
                </p>
              </div>
            </div>

            <div
              id="center"
              className={`py-2 px-6 list-items ${
                props.data.ecoBgImg && "!bg-transparent"
              }`}
            >
              <div
                className="grid grid-cols-7 gap-1 text-[#F0F3FA]"
                id="header"
              >
                <div>
                  {/* Day/Time */}
                  {TranslateInput("Day", "en", props.data.ecoLang)}
                  {"/"}
                  {TranslateInput("Time", "en", props.data.ecoLang)}
                  <span className="block">
                    {
                      dateRange(props.data.ecoDateFrom, props.data.ecoDateTo)
                        .gmt
                    }
                  </span>
                </div>
                <div className="col-span-4">
                  {TranslateInput("Country", "en", props.data.ecoLang)}
                  {"/"}
                  {TranslateInput("Event", "en", props.data.ecoLang)}
                </div>
                <div>
                  {TranslateInput("Expected", "en", props.data.ecoLang)}
                </div>
                <div>
                  {TranslateInput("Previous", "en", props.data.ecoLang)}
                </div>
              </div>

              {props.data.ecoDetails.map((detail, index) => {
                return (
                  <div
                    className="grid grid-cols-8 gap-1 text-white mt-2"
                    id="item"
                    key={index}
                  >
                    <div className="block">
                      <span className="block font-bold">{detail?.ecoDay}</span>
                      <span>{detail?.ecoTime}</span>
                    </div>
                    <div className="flex bg-[#FFFFFF1A] rounded-lg col-span-7 px-3 items-center col-wrapper">
                      <div className="flex -space-x-1 overflow-hidden flag-container">
                        <img
                          className="inline-block h-[35px] w-[35px] rounded-full"
                          src={detail?.ecoCountry}
                          alt={`country-${index}`}
                        />
                      </div>
                      <span className="country-event">{detail?.ecoEvent}</span>
                      <div className="flex w-[100px] justify-center">
                        {detail?.ecoExpected && (
                          <button
                            className={`badge bg-black/30 border-2 truncate ${
                              detail?.ecoMarketDirExp === "up"
                                ? "text-[#0576DB] border-[#0576DB]"
                                : "text-[#FC293A] border-[#FC293A]"
                            }`}
                            id="ecoMarketDirExp"
                            name={`ecoMarketDirExp${index}`}
                            value={
                              detail.ecoMarketDirExp === "down" ? "up" : "down"
                            }
                            onClick={props.handleEcoChange}
                          >
                            {detail?.ecoExpected}
                          </button>
                        )}
                      </div>
                      <div className="flex w-[100px] justify-center">
                        {detail?.ecoPrevious && (
                          <button
                            className={`badge text-[#09202c] truncate ${
                              detail.ecoMarketDirPrev === "up"
                                ? "bg-[#0576DB]"
                                : "bg-[#FC293A]"
                            }`}
                            id="ecoMarketDirPrev"
                            name={`ecoMarketDirPrev${index}`}
                            value={
                              detail.ecoMarketDirPrev === "down" ? "up" : "down"
                            }
                            onClick={props.handleEcoChange}
                          >
                            {detail?.ecoPrevious}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              id="bottom"
              className={`flex items-center ${
                props.data.ecoBgImg && "!bg-transparent"
              }`}
            >
              <img
                src="/go-logo-light.png"
                className="ml-[35.95px]"
                alt="go-logo"
                width="169.02px"
              />
              <p className="mr-[35.95px]">{props.data.ecoDomain}</p>
            </div>
          </div>

          {/* Generated component */}
          <div className="sr-only">
            <div
              id="gen-img"
              style={{
                backgroundImage: `url("${props.data.ecoBgImg}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              className={`DisplayImg ${props.data.ecoOverlay} lg:block`}
            >
              <div
                id="top"
                className={props.data.ecoBgImg && "!bg-transparent"}
              >
                <div className="flex py-4 mr-5 badge-block">
                  <span className="bg-primary text-[#fff] top-badge">
                    {
                      dateRange(props.data.ecoDateFrom, props.data.ecoDateTo)
                        .dateRange
                    }
                  </span>
                </div>
                <div className="flex items-center text-block">
                  <p className="font-inter">
                    {" "}
                    {TranslateInput(
                      "Economic Events",
                      "en",
                      props.data.ecoLang,
                    )}
                  </p>
                </div>
              </div>

              <div
                id="center"
                className={`py-2 px-6 list-items ${
                  props.data.ecoBgImg && "!bg-transparent"
                }`}
              >
                <div
                  className="grid grid-cols-8 gap-1 text-[#F0F3FA]"
                  id="header"
                >
                  <div className="">
                    {TranslateInput("Day", "en", props.data.ecoLang)}
                    {"/"}
                    {TranslateInput("Time", "en", props.data.ecoLang)}
                    <span className="block">
                      {
                        dateRange(props.data.ecoDateFrom, props.data.ecoDateTo)
                          .gmt
                      }
                    </span>
                  </div>
                  <div className="col-span-5">
                    {" "}
                    {TranslateInput("Country", "en", props.data.ecoLang)}
                    {"/"}
                    {TranslateInput("Event", "en", props.data.ecoLang)}
                  </div>
                  <div className="">
                    {TranslateInput("Expected", "en", props.data.ecoLang)}
                  </div>
                  <div className="">
                    {" "}
                    {TranslateInput("Previous", "en", props.data.ecoLang)}
                  </div>
                </div>

                {props.data.ecoDetails.map((detail, index) => {
                  return (
                    <div
                      className="grid grid-cols-8 gap-1 text-white"
                      id="item"
                      key={index}
                    >
                      <div className="block">
                        <span className="block day">{detail?.ecoDay}</span>
                        <span className="time">{detail?.ecoTime}</span>
                      </div>
                      <div className="flex bg-[#FFFFFF1A] rounded-lg col-span-7 px-4 items-center col-wrapper">
                        <div className="flex -space-x-1 overflow-hidden flag-container ">
                          <img
                            className="inline-block h-[50px] w-[50px] rounded-full"
                            src={detail?.ecoCountry}
                            alt={`country-${index}`}
                          />
                        </div>
                        <span className="country-event">
                          {detail?.ecoEvent}
                        </span>
                        <div className="flex w-[142.25px] justify-center">
                          {detail?.ecoExpected && (
                            <span
                              className={`badge bg-black/30 border-2 truncate ${
                                detail.ecoMarketDirExp === "up"
                                  ? "text-[#0576DB] border-[#0576DB]"
                                  : "text-[#FC293A] border-[#FC293A]"
                              }`}
                            >
                              {detail?.ecoExpected}
                            </span>
                          )}
                        </div>
                        <div className="flex w-[142.25px] justify-center">
                          {detail?.ecoPrevious && (
                            <span
                              className={`badge text-[#09202c] truncate ${
                                detail.ecoMarketDirPrev === "up"
                                  ? "bg-[#0576DB]"
                                  : "bg-[#FC293A]"
                              }`}
                            >
                              {detail?.ecoPrevious}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div
                id="bottom"
                className={`flex items-center px-6 ${
                  props.data.ecoBgImg && "!bg-transparent"
                }`}
              >
                <img src="/go-logo-light.png" alt="go-logo" width="233px" />
                <p>{props.data.ecoDomain}</p>
              </div>
            </div>
          </div>
          {/* End of generated component */}
          <div className="button-wrapper">
            <button
              type="button"
              className="btn mt-11 rounded st-4"
              onClick={(e) => {
                props.handleFormReset(e);
              }}
            >
              Reset Preview
            </button>
            <button
              className="btn btn-primary ease-linear transition-all duration-150 rounded st-5"
              type="button"
              onClick={props.handleJpeg}
            >
              Generate Image
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EcoCalendar;
